// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2iMpt","name":"ConsentHeader_name__1my3I","birthday":"ConsentHeader_birthday__RMzQ4","skeleton":"ConsentHeader_skeleton__33a91"};